import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client/react';

interface IUseGroupUserCountOptions {
    groupId: string;
}

export const useGroupUserCount = ({ groupId }: IUseGroupUserCountOptions) => {
    const client = useApolloClient();

    const updateGroupUserCount = useCallback(
        (countDelta: number) => {
            client.cache.modify({
                id: `Group:${groupId}`,
                fields: {
                    userCount(existing = 0) {
                        return existing + countDelta;
                    },
                },
            });
        },
        [client.cache, groupId]
    );

    return { updateGroupUserCount };
};
